module.exports = __webpack_public_path__ + "static/media/FutureGlyphs.362d52f0.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/fonts/FutureGlyphs.woff
 ** module id = 432
 ** module chunks = 0
 **/